export const UserPreferenceKeys = {
  DashboardMyDayDailyBriefCollapsedOperationalBaseIds: 'dashboard.myDay.dailyBrief.collapsedOperationalBaseIds',
  DashboardRailHiddenGroupIds: 'dashboard.rail.hiddenGroupIds',
} as const

export type UserPreferenceKey = typeof UserPreferenceKeys[keyof typeof UserPreferenceKeys]

export interface DashboardMyDayDailyBriefCollapsedOperationalBaseIdsPreference {
  operationalBaseIds: number[]
}

export interface DashboardRailHiddenGroupIdsPreference {
  groupIds: string[]
}

export interface UserPreferences {
  [UserPreferenceKeys.DashboardMyDayDailyBriefCollapsedOperationalBaseIds]: DashboardMyDayDailyBriefCollapsedOperationalBaseIdsPreference
  [UserPreferenceKeys.DashboardRailHiddenGroupIds]: DashboardRailHiddenGroupIdsPreference
}

export const defaultUserPreferences: UserPreferences = {
  [UserPreferenceKeys.DashboardMyDayDailyBriefCollapsedOperationalBaseIds]: {
    operationalBaseIds: [],
  },
  [UserPreferenceKeys.DashboardRailHiddenGroupIds]: {
    groupIds: [],
  },
}

export interface UserPreferenceUpdate<K extends UserPreferenceKey = UserPreferenceKey> {
  key: K
  value: UserPreferences[K]
}
